import { useState } from 'react'
import '../../packs/Garage/styles.scss'
import { successToast } from '../../lib/toastAlert'

export const GarageModalItem = (props) => {
  const [list, setList] = useState(props.list)

  const addToList = () => {
    const { id, title } = list

    App.Request.post(`/account/listings/${id}/listing_items`, {
      car_id: props.carId,
    }).then((response) => {
      const { data, status } = response
      if (status === 200) {
        successToast({ title: I18n.t('garage.car_added', { garage: title }) })

        setList(data)
      }
    })
  }

  const removeFromList = () => {
    const { id, title } = list

    App.Request.delete(
      `/account/listings/${id}/listing_items/${props.carId}`
    ).then((response) => {
      const { data, status } = response
      if (status === 200) {
        successToast({ title: I18n.t('garage.car_removed', { garage: title }) })

        setList(data)
      }
    })
  }

  const toggleList = () => {
    if (list.is_car_in_list) {
      removeFromList()
    } else {
      addToList()
    }
  }

  /* eslint-disable camelcase */
  const { title, items_count, is_car_in_list, follow_price } = list

  return (
    <button
      type="button"
      onClick={toggleList}
      className="d-flex btn bg-gray my-1 p-3 rounded justify-content-between w-100 align-items-center"
    >
      <div className="d-flex align-items-center text-truncate">
        <i
          className={`
          ${
            is_car_in_list ? 'fas fa-check-square' : 'far fa-square'
          } text-primary fa-lg mx-2`}
        />
        <span className="fw-bolder text-truncate">{title}</span>
      </div>
      <div className="d-flex align-items-center text-muted ms-2">
        <span>
          {items_count} {I18n.t('cars_noun')}
        </span>
        <i
          className={`far fa-lg fa-fw ${
            follow_price ? 'fa-bell' : 'fa-bell-slash'
          } mx-2`}
          title={follow_price ? 'Following price' : 'Not following price'}
        />
      </div>
    </button>
  )
}
